// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-skill-band-title {
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 15px;
}

.container-skill-band-data {
  width: 30%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px;
}

.text {
  font-size: 16px;
  text-transform: uppercase;
}

.container-skill-band {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100px;
  position: relative;
}

.text.title {
  font-weight: bold;
}

.value {
  width: 100%;
  text-align: left;
  font-size: 20px;
}

/* Media query for mobile */
@media (max-width: 768px) {
  .value {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/widget-counter-band/widget-counter-band.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;AACF;;AAEA;EACE,eAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA,2BAAA;AACA;EAEE;IACE,eAAA;EAAF;AACF","sourcesContent":[".container-skill-band-title {\n  width: 70%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-left: 15px;\n}\n\n.container-skill-band-data {\n  width: 30%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 10px;\n}\n\n.text {\n  font-size: 16px;\n  text-transform: uppercase;\n}\n\n.container-skill-band {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: 100px;\n  position: relative;\n}\n\n.text.title {\n  font-weight: bold;\n}\n\n.value {\n  width: 100%;\n  text-align: left;\n  font-size: 20px;\n}\n\n/* Media query for mobile */\n@media (max-width: 768px) {\n\n  .value {\n    font-size: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
